import moment from "moment";
import Constants from "../constants/constants";
import { dispatcher } from "../dispatcher/dispatcher";

import { storeUtils } from "./util";

const { ActionTypes, Roles } = Constants;

var _events = new storeUtils.EventEmitter();
var CHANGE_EVENT = "change";
var USER_ROLES_EVENT = "userRolesFetched";

var _userRoles = [Roles.SUPER_USER];
var _selectedRole = [Roles.SUPER_USER];
var _user; //store all the user details so we can get at them later
var _activeOverride; //stores the active override for the user if one exists
var _expiredOverride; //store the expired override to show the override expired indicator
var _overrideExpiredByAdmin = false;

var _printLataId = localStorage.printLata; //either the lata or undefined...

function defaultFieldPrintLata() {
  //If the user has been loaded or set to field user and they don't have a stored print lata, default it to IMS2TRSH
  if (_printLataId === undefined || _printLataId === "") {
    _printLataId = "IMS2TRSH";
    localStorage.printLata = _printLataId;
  }
}

var dispatchToken = dispatcher.register(function (action) {
  //this action comes from the dispatcher
  switch (action.type) {
    case ActionTypes.PRINT_LATA_CHANGED:
      _printLataId = action.lata;
      //store it to local storage for next time....
      localStorage.printLata = action.lata;
      _events.trigger(CHANGE_EVENT);
      break;
    case ActionTypes.USER_CHANGED:
      _selectedRole = action.role;
      if (_selectedRole[0] == Roles.SUPER_USER) {
        _selectedRole.push(Roles.ADMIN);
        _selectedRole.push(Roles.DISPATCHER);
      } else if (_selectedRole[0] == Roles.ADMIN) {
        _selectedRole.push(Roles.DISPATCHER);
      } else if (_selectedRole[0] == Roles.FIELD_USER) {
        defaultFieldPrintLata();
        for (var i = 0; i < _userRoles.length; i++) {
          if (Roles.FIELD_USER_ROLE.indexOf(_userRoles[i]) > -1) {
            _selectedRole.push(_userRoles[i]);
          }
          //push slodt if they have that
          if (Roles.FIELD_SLODT == _userRoles[i]) {
            _selectedRole.push(_userRoles[i]);
          }
        }
      }
      _events.trigger(CHANGE_EVENT);
      break;
    case ActionTypes.SET_USER_ROLE:
      _user = action.user;

      _userRoles = _user.roles;

      if (!_user.isDispatcherDesk) {
        //If they are not a dispatcher desk, default to IMS2TRSH
        //Dispatcher machine defaults are handled by the /stores/territory.js
        defaultFieldPrintLata();
      }

      if (Roles.FIELD_USER_ROLE.indexOf(_userRoles[0]) > -1) {
        _selectedRole = [Roles.FIELD_USER];
      } else {
        _selectedRole = [_userRoles[0]];
      }

      if (_selectedRole[0] === Roles.SUPER_USER) {
        _selectedRole.push(Roles.ADMIN);
        _selectedRole.push(Roles.DISPATCHER);
      } else if (_selectedRole[0] === Roles.ADMIN) {
        _selectedRole.push(Roles.DISPATCHER);
      } else if (_selectedRole[0] === Roles.FIELD_USER) {
        for (var i = 0; i < _userRoles.length; i++) {
          if (Roles.FIELD_USER_ROLE.indexOf(_userRoles[i]) > -1) {
            _selectedRole.push(_userRoles[i]);
          }
          //push slodt if they have that
          if (Roles.FIELD_SLODT === _userRoles[i]) {
            _selectedRole.push(_userRoles[i]);
          }
        }
      }

      _events.trigger(CHANGE_EVENT);
      break;
    case ActionTypes.OVERRIDE_GRANTED:
      _activeOverride = JSON.parse(action.override);
      _activeOverride.createTimeStamp = moment(_activeOverride.createTimeStamp);
      _activeOverride.expireTimeStamp = moment(_activeOverride.expireTimeStamp);

      _expiredOverride = null;

      _events.trigger(CHANGE_EVENT);
      break;
    case ActionTypes.OVERRIDE_EXPIRED:
      _expiredOverride = JSON.parse(action.override);
      _expiredOverride.createTimeStamp = moment(
        _expiredOverride.createTimeStamp
      );
      _expiredOverride.expireTimeStamp = moment(
        _expiredOverride.expireTimeStamp
      );

      //expire the current active override
      _activeOverride = null;

      //If the override was expired by an admin, mark it
      if (action.fromAdmin) _overrideExpiredByAdmin = true;

      _events.trigger(CHANGE_EVENT);
      break;
    case ActionTypes.OVERRIDE_CLEAR_EXPIRED: //This is called to remove the expired indicator on the client ui
      _expiredOverride = null;

      _events.trigger(CHANGE_EVENT);
      break;
    case ActionTypes.SUBMIT_TO_SERVER_SUCCESSFUL: //If the user submits to the server, clear the override indicator. The server will signal the client to check override status once the message is processed
      _activeOverride = null;
      _expiredOverride = null;

      _events.trigger(CHANGE_EVENT);
      break;

    default:
    //no op
  }
}); //end of dispatch token

//public api
export const userStore = {
  dispatchToken,
  subscribe: _events.on,
  unsubscribe: _events.off,
  getUserType: () => _userRoles,
  getUserRole: () => _userRoles,
  isDispatcherRole: () => _selectedRole.indexOf(Roles.DISPATCHER) > -1,
  getSelectedRole: () => _selectedRole,
  getActiveOverride: () => _activeOverride,
  getExpiredOverride: () => _expiredOverride,
  getOverrideExpiredByAdminFlag: () => _overrideExpiredByAdmin,
  isDispatcher: () => _user ? _user.isDispatcherDesk : false,
  getUser: () => _user,
  getLata: () => _printLataId,
};
